class Wishlist {
  constructor() {
    this.wishlist = localStorage.getItem("wishlist")
      ? localStorage.getItem("wishlist").split(",")
      : [];

    this.selectors = {
      addToWishlist: "[data-wishlist-add]",
      removeFromWishlist: "[data-wishlist-remove]",
      wishlistCount: "[data-wishlist-count]",
      wishlistAddText: "[data-wishlist-text]",
      wishlistContainer: "#WishlistContainer",
    };

    document
      .querySelectorAll(this.selectors.addToWishlist)
      .forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.add(button);
        });
      });

    this.wishlistContainer = document.querySelector(
      this.selectors.wishlistContainer
    );
    if (this.wishlistContainer) {
      this.fillWishlistContainer();
    }
    this.updateWishlistCount();

    document.addEventListener("WishlistProductsListed", () => {
      this.updateWishlistButtons();
    });
    this.updateWishlistButtons();
  }

  fetchWishlistProductCard(handle) {
    return fetch(
      `/products/${handle}?view=wishlist&section_id=static-product-wishlist`
    );
  }

  async fillWishlistContainer() {
    const responses = await Promise.allSettled(
      this.wishlist.map((handle) => this.fetchWishlistProductCard(handle))
    );

    // Process responses

    for (let index = 0; index < responses.length; index++) {
      const response = responses[index];
      if (response.status === "fulfilled") {
        // You can directly use response.value as it's already awaited
        const data = await response.value.text();
        const productItem = new DOMParser()
          .parseFromString(data, "text/html")
          .body.firstChild.querySelector("li");

        productItem
          .querySelectorAll("img")
          .forEach((img) => img.removeAttribute("srcset"));
        this.wishlistContainer.innerHTML += productItem.outerHTML;
        document.dispatchEvent(new CustomEvent("WishlistProductsListed"));
      }
    }
  }

  updateWishlistButtons() {
    document
      .querySelectorAll(this.selectors.addToWishlist)
      .forEach((button) => {
        if (this.wishlist.find((itm) => itm == button.dataset.product)) {
          console.log(button);
          button.classList.add("added-to-wishlist");
          if (button.querySelector(this.selectors.wishlistAddText))
            button.querySelector(this.selectors.wishlistAddText).innerText =
              window.Theme.wishlist.addedToWishlistText;
        }
      });
  }

  add(button) {
    const product = button.dataset.product;
    if (this.wishlist.find((p) => p === product)) {
      this.remove(button);
      return;
    }

    this.wishlist.push(product);
    localStorage.setItem("wishlist", this.wishlist.join(","));

    button.classList.add("added-to-wishlist");
    if (button.querySelector(this.selectors.wishlistAddText))
      button.querySelector(this.selectors.wishlistAddText).innerText =
        window.Theme.wishlist.addedToWishlistText;

    this.updateWishlistCount();
  }

  remove(button) {
    const product = button.dataset.product;
    this.wishlist = this.wishlist.filter((p) => p !== product);
    localStorage.setItem("wishlist", this.wishlist.join(","));

    button.classList.remove("added-to-wishlist");

    if (button.querySelector(this.selectors.wishlistAddText))
      button.querySelector(this.selectors.wishlistAddText).innerText =
        window.Theme.wishlist.addToWishlistText;

    this.updateWishlistCount();

    if (button.closest(this.selectors.wishlistContainer)) {
      button.closest("li").remove();
    }
  }

  updateWishlistCount() {
    const wishlistCounts = document.querySelectorAll(
      this.selectors.wishlistCount
    );
    wishlistCounts.forEach((wishlistCount) => {
      wishlistCount.textContent = this.wishlist.length;
      this.wishlist.length > 0
        ? wishlistCount.classList.add("visible")
        : wishlistCount.classList.remove("visible");
    });
  }
}

new Wishlist();
